<template>
  <div>
    <div class="title"><span class="box-name">专题图片</span></div>

    <div class="line_one" :style="barrageIsShow ? 'opacity:1' : 'opacity:0'" v-if="barrageList">
      <div class="swiper-container swiper-container1 swiper-no-swiping">
        <div class="swiper-wrapper">
          <div class="swiper-slide" style="width:80%;" v-for="(item, index) in barrageList" :key="index">
            <div class="item">
              <div class="item_box">
                <div class="item_main">
                  <img :src="item.sytpurl" alt @click="getArticle(item.id,'专题图片')"/>
                  <dl>
                    <dt>{{ item.title }}</dt>
                    <dd></dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
export default {
  data() {
    return {
      barrageList: [

      ],
      barrageIsShow: true
    };
  },
  mounted() {

    this.findPageList();
  },
  methods: {
    getArticle(articleId,menutext){
      let {
        href
      } = this.$router.resolve({
        path: "/Article", // 这里写的是要跳转的路由地址
        query: {
          articleId: articleId,
          menutext:menutext
        } // 这里写的是页面参数
      });
      window.open(href, '_blank');

    },
    getList() {
      this.swiper_init('.swiper-container1');
    },
    swiper_init(obj) {
      var that = this;
      that.$nextTick(function() {
        var mySwiper = new Swiper(obj, {
          loop: true, //允许从第一张到最后一张，或者从最后一张到第一张  循环属性
          slidesPerView: 6, // 设置显示三张
          //centeredSlides : true,     //使当前图片居中显示
          freeMode: true, // 使幻灯片滑动时不止滑动一格，且不会自动贴合
          slidesPerGroup: 1, //定义1张图片为一组
          autoplay: true, //可选选项，自动滑动
          speed: 3000, //设置过度时间
          grabCursor: true, //鼠标样式根据浏览器不同而定
          autoplay: {
            delay: 10,
            stopOnLastSlide: false,
            disableOnInteraction: false
          }
        });
      });
    },
    findPageList(){
      var that = this;
      that.$myHttp.post("findPageList?type=44&pageSize=-1").then(function(data){
          console.log(data)
          if (data.status == "200") {
              that.barrageList = data.data.page.list;
              that.getList();
          }  else {
            alert("数据请求错误")
          }

      }).catch(function(error){
        alert(error)
      })
    }
  }
};
</script>
<style>
.line_one {
  height: 150px;
  width: 100%;
  position: relative;
}
.title {
  height: 36px;
  line-height: 36px;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #199352;
}
.title .box-name {
  font-size: 14px;
  color: #fff;
  background: #199352;
  font-weight: bold;
  padding: 0 10px;
}
.line_one:first-child {
  margin-top: 0.18rem;
  margin-bottom: 0.12rem;
}
.item .item_box {
  display: inline-block;
  border-radius: 0.48rem;
  background: rgba(255, 255, 255, 0.5);
  padding: 0.1rem 0.3rem 0.1rem 0.1rem;
  padding: 10px;
}
.item .item_main {
  display: flex;
  flex-direction: column;
}
.item .item_main img {
  width: 100%;
  height: 100px;
}
dl {
  flex: 1;
}
dl dt {
  color: #666;
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/front/components/zhuanti.vue